// extracted by mini-css-extract-plugin
export default {"buttonContainer":"SelectProjectMenu_buttonContainer__hnizz","button":"SelectProjectMenu_button__Atrd-"};